import { ArrowDropDown } from '@mui/icons-material'
import { getPublicCompressed } from '@toruslabs/eccrypto'
import axios from 'axios'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { CATEGORY_MENU_IMAGES } from '../../../constants/static'
import { useWeb3Auth } from '../../../services/web3auth'
import useAuthStore from '../../../store/authStore'
import useUploadStore from '../../../store/uploadStore'
import SearchBox from '../SearchBox'

const MobileBottomBar = ({
  currentCategory,
  currentQuery,
  setSearchCategory,
  parent,
}: any) => {
  const [searchBox, setSearchBox] = useState(false)
  const [loader, setLoader] = useState<boolean>(true)
  const [saltBalance, setSaltBalance] = useState<any>()
  const [maticBalance, setMaticBalance] = useState<any>()
  const [walletAddress, setWalletAddress] = useState<string>('')
  const [categoryOpen, setCategoryOpen] = useState<boolean>(false)
  const router = useRouter()
  const { setActiveStep, setCurrentCategory, setUploadAssetId } =
    useUploadStore()

  const [active, setActive] = useState('')

  const user_id = useAuthStore((state) => state.userInfo)

  // For getting user verified
  const [secretKey, setSecretKey] = useState<any>()
  const [idToken, setIdToken] = useState<any>()
  const [typeOfLogin, setTypeOfLogin] = useState<any>()

  const { getCategoryList, categoryList } = useUploadStore()
  const { setCurrentUser, setOpenLogginDetails } = useAuthStore()
  const { logout } = useWeb3Auth()

  const [category, setCategory] = useState('All Categories')
  let [userName, setUserName] = useState<string>('')
  let [userProfileImage, setUserProfileImage] = useState<string>('')
  const [menu, setMenu] = useState(false)

  useEffect(() => {
    const path = router.route
    if (path === '/') setActive('discover')
    else setActive(path.slice(1).split('/')?.[0])
  }, [category, active, router])

  useEffect(() => {
    getCategoryList()
    if (walletAddress) return
    let x = setInterval(function () {
      setLoader(false)
    }, 4000)
    return () => clearInterval(x)
  }, [])

  const {
    provider,
    getAccounts,
    getMaticBalance,
    getPrivateKey,
    isLoading,
    metaMaskSign,
  } = useWeb3Auth()

  async function getCredentials() {
    setLoader(true)
    const wallet = await localStorage.getItem('WalletAddress')
    if (wallet !== null && wallet !== undefined) {
      setUserName(wallet)
      setLoader(false)
    }
    const crendetials = await localStorage.getItem('openlogin_store')
    if (crendetials !== null && crendetials !== undefined) {
      const user = JSON.parse(crendetials)
      setOpenLogginDetails(JSON.parse(crendetials))
      setIdToken(user.idToken)
      setTypeOfLogin(user.typeOfLogin)
    }
    setLoader(false)
  }

  useEffect(() => {
    if (provider) {
      if (
        !user_id ||
        user_id == undefined ||
        !walletAddress ||
        walletAddress == undefined
      )
        return
      const config = { user: { uid: user_id } }
      // console.log('config', config)
      axios
        .post(
          'https://us-central1-test-69192.cloudfunctions.net/userAuth/getWallet',
          config
        )
        .then((res) => {
          // const data = res?.data?.data?.data
          if (res?.data?.data?.salt) {
            setSaltBalance(res?.data?.data?.salt)
          } else {
            setSaltBalance(0)
          }
        })
        .catch((e) => {
          console.log(e)
        })

      Object.assign(config, { wallet_address: walletAddress })
      // console.log('Data is', config)
      if (typeOfLogin == 'jwt') {
        axios
          .post(
            'https://us-central1-test-69192.cloudfunctions.net/userAuth/updateWallet',
            config
          )
          .then((res) => console.log(res))
          .catch((e) => console.log(e?.response?.data?.message))
      }
    }
  }, [user_id, provider, walletAddress])

  useEffect(() => {
    if (provider) {
      getAccounts().then(() => {
        const address = localStorage.getItem('WalletAddress')
        if (address !== null && address !== undefined) {
          setWalletAddress(address)
          // console.log(walletAddress)
        }
      })
      if (walletAddress != '' && !isLoading && !loader) {
        getMaticBalance().then((data) =>
          setMaticBalance((data / 1e18).toFixed(2))
        )
      }

      const adapter = localStorage.getItem('Web3Auth-cachedAdapter')

      // TODO:
      if (adapter == 'wallet-connect-v1') {
        const walletConnect = localStorage.getItem('walletconnect')
        if (walletConnect !== null && walletConnect !== undefined) {
          // console.log('Hello there', walletConnect)
          // console.log('walletconnect login flow ')
          metaMaskSign()
            .then((data) => {
              const uid = data?.data?.data?.wallet?.address
              if (uid != undefined) {
                setCurrentUser(uid)
                localStorage.setItem('uid', uid)
              }
            })
            .catch((e) => {
              console.log(e)
            })

          localStorage.setItem('signature', '1')
        }
      }
      const isSigned = localStorage.getItem('signature')
      if (adapter == 'metamask' && isSigned == '0') {
        // console.log('metamask login flow ')
        metaMaskSign()
          .then((data) => {
            const uid = data?.data?.data?.wallet?.address

            if (uid != undefined) {
              setCurrentUser(uid)
              localStorage.setItem('uid', uid)
            }
          })
          .catch((e) => {
            // console.log(e)
          })

        localStorage.setItem('signature', '1')
      }

      if (typeOfLogin == 'discord') {
        // console.log('Only Discord Login goes here')
        // localStorage.setItem('uid', walletAddress)
        getPrivateKey().then((data) => {
          // console.log(data)
          setSecretKey(data)
        })

        let app_pub_key

        if (secretKey != undefined) {
          app_pub_key = getPublicCompressed(
            Buffer.from(secretKey.padStart(64, '0'), 'hex')
          ).toString('hex')
        }
        // console.log('secret key', secretKey)
        // console.log('app_pub_key', app_pub_key)

        const verifierData = {
          app_pub_key: app_pub_key,
          idToken: idToken,
          address: walletAddress,
          name: userName,
        }
        // console.log(verifierData)

        axios
          .post(
            'https://us-central1-test-69192.cloudfunctions.net/app/getverified-social',
            verifierData
          )
          .then((res) => {
            // console.log('response for discode', res)
            setCurrentUser(walletAddress)
            localStorage.setItem('uid', walletAddress)
          })
          .catch((e) => {
            // console.log(e)
          })
      }

      if (typeOfLogin == 'jwt' && localStorage.getItem('uid') === null) {
        const crendetials = localStorage.getItem('openlogin_store')
        if (crendetials !== null && crendetials !== undefined) {
          const user = JSON.parse(crendetials)
          // localStorage.setItem('uid', user.verifierId)
          const authToken = user.oAuthIdToken

          const config = {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
          const body = {
            idToken: authToken,
          }
          // console.log(config)
          axios
            .post(
              'https://us-central1-test-69192.cloudfunctions.net/app/valid',
              body,
              config
            )
            .then(async (res) => {
              // console.log('response', res)
              // console.log('result', JSON.parse(res.data.data.token))
              const result = JSON.parse(res.data.data.token)
              setCurrentUser(result.uid)
              localStorage.setItem('uid', result.uid)
            })
            .catch((e) => {
              console.log('error occured', e)
            })
        }
      }

      if (!userName || !userProfileImage) {
        getCredentials()
      }
    }
  }, [userName, loader, getAccounts, provider, walletAddress])

  const openMenu = (type: string) => {
    if (type === 'open') {
      setMenu(true)
      document.body.style.overflow = 'hidden'
    } else {
      setMenu(false)
      document.body.style.overflow = 'auto'
    }
  }

  return (
    <div className="flex h-12 flex-row items-center justify-between border-b-2 border-gray-800 md:hidden">
      {searchBox ? (
        <SearchBox
          key={String(Math.random()).slice(2, 10)}
          currentCategory={currentCategory}
          currentQuery={currentQuery}
          setSearchCategory={setSearchCategory}
          parent={parent}
        />
      ) : (
        <div className="flex flex-row items-center justify-center pl-2 md:pl-10">
          <Link href="/">
            <button
              className={`group flex flex-row items-center justify-center border-b-2 px-3 py-3 hover:border-primary ${
                active === 'discover' || active === 'trending'
                  ? 'border-b-2 border-primary'
                  : 'border-transparent'
              }`}
              onClick={() => openMenu('close')}
            >
              <Image
                width={18}
                height={18}
                alt="explore"
                className={`${
                  active === 'discover' || active === 'trending'
                    ? 'grayscale-0'
                    : 'grayscale'
                } group-hover:grayscale-0`}
                src="/icons/explore.svg"
              />
              <span
                className={`group-hover:text-yellow-200 ${
                  active === 'discover' || active === 'trending'
                    ? 'text-primary'
                    : 'text-white'
                }  ml-2 font-oswaldregular text-sm uppercase`}
              >
                Discover
              </span>
            </button>
          </Link>
          <button
            className={`flex flex-row items-center justify-center border-b-2 px-3 py-3 hover:border-primary ${
              active === 'categories'
                ? 'border-b-2 border-primary'
                : 'border-transparent'
            }`}
            onClick={() => setCategoryOpen(!categoryOpen)}
          >
            <Image
              width={18}
              height={18}
              alt="categories"
              className={`${
                active === 'categories' || categoryOpen
                  ? 'grayscale-0'
                  : 'grayscale'
              } group-hover:grayscale-0`}
              src="/icons/categories.svg"
            />
            <span
              className={`group-hover:text-yellow-200 ${
                active === 'categories' || categoryOpen
                  ? 'text-primary'
                  : 'text-white'
              } ml-2 font-oswaldregular text-sm uppercase`}
            >
              Categories
            </span>
            <ArrowDropDown
              className={`${
                active === 'categories' || categoryOpen
                  ? 'text-primary'
                  : 'text-white'
              } h-5 w-5 group-hover:text-primary `}
            />
          </button>
          {categoryOpen ? (
            <div
              className="absolute top-24 left-0 flex h-[80vh] w-full flex-col items-start justify-start overflow-x-hidden overflow-y-scroll border-b-2 border-primary bg-black p-4 transition-all"
              id="categories-container"
            >
              {categoryList.map((category, index) => (
                <Link
                  key={index}
                  href={
                    index === 0 ? '/categories' : `/categories/${category.key}`
                  }
                >
                  <div
                    onClick={() => setCategoryOpen(false)}
                    className="m-1 flex w-full  cursor-pointer flex-row items-start justify-start bg-gray-900 px-2 py-2 transition-all hover:bg-gray-600 "
                  >
                    <Image
                      src={CATEGORY_MENU_IMAGES[category.key] || '/3dmodal.png'}
                      alt="category"
                      layout="fixed"
                      width={60}
                      height={60}
                    />
                    <div className="ml-4 flex flex-col items-start text-white">
                      <span className="font-oswaldregular text-lg">
                        {category?.name}
                      </span>
                      <span className="w-56 truncate font-oswaldregular text-[12px] opacity-60">
                        {category?.description?.[0]}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <></>
          )}
          <Link href="/upload">
            <button
              className={`group flex flex-row items-center justify-center border-b-2 px-3 py-3 hover:border-primary ${
                active === 'upload'
                  ? 'border-b-2 border-primary'
                  : 'border-transparent'
              }`}
              onClick={() => {
                setActiveStep(-1)
                setUploadAssetId('')
                setCurrentCategory(undefined)
                setCategoryOpen(false)
              }}
            >
              <Image
                width={18}
                height={18}
                alt="upload"
                className={`${
                  active === 'upload' ? 'grayscale-0' : 'grayscale'
                } group-hover:grayscale-0`}
                src="/icons/upload.svg"
              />
              <span
                className={`group-hover:text-primary ${
                  active === 'upload' ? 'text-primary' : 'text-white'
                } ml-2 font-oswaldregular text-sm uppercase`}
              >
                Upload
              </span>
            </button>
          </Link>
        </div>
      )}

      {/* // Adding Provider Variable to check the user is logged in or not */}

      {provider && (
        <div className="-mr-4 hidden -skew-x-12 transform flex-row items-center justify-center border-2 border-green-700 bg-gray-800 px-6 py-1 text-white md:flex">
          <div className="flex skew-x-12 transform flex-row items-center justify-center">
            <Image
              width={28}
              height={24}
              src="/icons/salt.png"
              alt={'salt image'}
            />
            <span className="font-spaceMonoregular mr-2 ml-2 text-sm">
              {isNaN(saltBalance) ? '...' : saltBalance}
            </span>
          </div>
          <div className="flex skew-x-12 transform flex-row items-center justify-center">
            <Image
              width={24}
              height={24}
              src="/icons/polygon.png"
              alt={'matic image'}
            />
            <span className="font-spaceMonoregular mr-2 ml-2 text-sm">
              {isNaN(maticBalance) ? 0 : maticBalance}
            </span>
          </div>
        </div>
      )}

      <div
        className={`md:hidden ${searchBox ? 'm-4 mt-5' : 'mr-4'} opacity-60`}
        onClick={() => setSearchBox(!searchBox)}
      >
        {searchBox ? (
          <Image
            width={24}
            height={24}
            alt="close"
            className="brightness-0 grayscale invert"
            src="/icons/close-red.svg"
          />
        ) : (
          <Image
            width={24}
            height={24}
            alt="search"
            className="invert"
            src="/icons/search.svg"
          />
        )}
      </div>
    </div>
  )
}

export default MobileBottomBar
